// invoiceHelpers.js

export function getFormKeyByTitle(title) {
  switch (title) {
    case "Sales_Bill":
      return "Sales_Bill";
    case "Consignment_Note":
      return "Consignment_Note";
    case "FTL_Consignment_Note":
      return "FTL_Consignment_Note";
    case "Connection_Memo":
      return "Connection_Memo";
    case "Delivery_Memo":
      return "Delivery_Memo";
    default:
      return "LMS_Sales_Bill"; // fallback
  }
}

export function getQueryNameByTitle(title) {
  switch (title) {
    case "Sales_Bill":
      return "generate_pdf_Sales_Bill";
    case "Consignment_Note":
      return "generate_CN_pdf";
    case "FTL_Consignment_Note":
      return "generate_FTL_CN_pdf";
    case "Connection_Memo":
      return "generate_Connection_Memo_pdf";
    case "Delivery_Memo":
      return "generate_Delivery_Memo_pdf";
    default:
      return "generate_LMS_pdf"; // fallback
  }
}
